module.exports = __webpack_public_path__ + "a583a17dd6280802afb0a4ac5b7d60f1.svg";